import { render, staticRenderFns } from "./MemberListDefaultLayout.vue?vue&type=template&id=ab4b61dc&scoped=true"
import script from "./MemberListDefaultLayout.vue?vue&type=script&lang=js"
export * from "./MemberListDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4b61dc",
  null
  
)

export default component.exports